import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GestionnaireGuard } from '../core/guards/gestionnaire.guard';
import { RoleGuard } from '../core/guards/role.guard';
import { ROLES } from '../core/constants/roles.constants';

export const PERSONNEL_ROUTES: Routes = [
  {
    path: 'referents/list',
    loadComponent: () => import('../features/referents/list/list.component').then(m => m.ReferentsListComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'personnel/list',
    loadComponent: () => import('../features/personnel/list/list.component').then(m => m.PersonnelListComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'user-sessions/list',
    loadComponent: () => import('../features/user-sessions/list/list.component').then(m => m.UserSessionsListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.EHPAD, ROLES.TECH],
    },
  },
  {
    path: 'impersonation-logs/list',
    loadComponent: () =>
      import('../features/impersonation-logs/list/list.component').then(m => m.ImpersonationLogsListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'batch-import',
    loadComponent: () => import('../features/batch-import/list/list.component').then(m => m.BatchImportListComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'personnel/add',
    loadComponent: () => import('../features/personnel/add/add.component').then(m => m.PersonnelAddComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'personnel/edit/:id',
    loadComponent: () => import('../features/personnel/edit/edit.component').then(m => m.PersonnelEditComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
];
